import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import InputAdornment from '@mui/material/InputAdornment';

import DateRange from '../../components/date/DateRange';
import { TextFieldWhite } from '../../components/customStyles/form';
import PoperButton from '../../components/poper/PoperButton';
import { CloseOutlinedIcon, SearchIcon } from '../../components/customStyles/images';

import { POSITION } from '../../constants/global';

import theme from '../../theme';


const FilterCondition = ({
  searchKeyword,
  setSearchKeyword,
  dateRange,
  setDateRange,
  isLoading,
  fetchDownloadUser,
  getUserList
}) => {
  const isMoblie = useMediaQuery(theme.breakpoints.down('md'));

  const handleSearchInput = (e) => {
    setSearchKeyword(e.target.value);
  }

  const handelSearchActive = () => {
    if (searchKeyword) {
      getUserList();
    }
  }

  const handelSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      getUserList();
    }
  }

  return (
    <>
      {!isMoblie &&
        <>
          <Stack variant="start-center" mb={1}>
            <Typography
              variant="h5"
              mr={2}
              color={theme.palette.grey.w600}
              sx={{ display: { md: 'none', lg: 'block' } }}
            >
              搜尋
            </Typography>

            <Box>
              <TextFieldWhite
                id="search"
                placeholder="UID | 姓名 | Email | 電話"
                value={searchKeyword}
                onChange={handleSearchInput}
                onKeyDown={handelSearchKeyDown}
                endAdornment={
                  <InputAdornment
                    position="end"
                    sx={{
                      paddingRight: 1,
                      '&:hover': { color: theme.palette.primary.main }
                    }}
                  >
                    <SearchIcon onClick={handelSearchActive} />
                  </InputAdornment>
                }
                sx={{ cursor: 'pointer', width: '360px' }}
              />
            </Box>
          </Stack>

          <Stack ml={2}>
            <Stack variant="start-center" mb={1}>
              <Typography
                variant="h5"
                mr={2}
                color={theme.palette.grey.w600}
                sx={{ display: { md: 'none', lg: 'block' } }}
              >
                時間
              </Typography>

              <Box>
                <DateRange
                  type="white"
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  anchorHorizontal={POSITION.RIGHT}
                />
              </Box>

            </Stack>

            <Box ml={2} mb={1}>
              <PoperButton
                iconLoading={isLoading}
                fetchDownloadData={fetchDownloadUser}
              />
            </Box>
          </Stack>
        </>
      }
      {isMoblie &&
        <Stack>
          <Stack variant="start-center" mb={1}>
            <Typography
              variant="h5"
              mr={2}
              color={theme.palette.grey.w600}
              sx={{ display: { xs: 'none', md: 'none', lg: 'block' } }}
            >
              搜尋
            </Typography>

            <Box>
              <TextFieldWhite
                id="search"
                placeholder="輸入關鍵字"
                value={searchKeyword}
                onChange={handleSearchInput}
                endAdornment={
                  <InputAdornment position="end" sx={{ paddingRight: 1 }}>
                    <SearchIcon onClick={getUserList} />
                  </InputAdornment>
                }
              />
            </Box>
          </Stack>

          <Stack sx={{ ml: { xs: 0, sm: '16px' } }}>
            <Stack variant="start-center" mb={1}>
              <Typography
                variant="h5"
                mr={2}
                color={theme.palette.grey.w600}
                sx={{ display: { xs: 'none', md: 'none', lg: 'block' } }}
              >
                時間
              </Typography>

              <Box>
                <DateRange
                  type="white"
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  anchorHorizontal={POSITION.RIGHT}
                />
              </Box>

            </Stack>

            <Box ml={2} mb={1}>
              <PoperButton
                iconLoading={isLoading}
                fetchDownloadData={fetchDownloadUser}
              />
            </Box>
          </Stack>
        </Stack>
      }
    </>
  )
}

export default FilterCondition;